import { render, staticRenderFns } from "./postReComment.vue?vue&type=template&id=a5ae5454&lang=pug&"
import script from "./postReComment.vue?vue&type=script&lang=js&"
export * from "./postReComment.vue?vue&type=script&lang=js&"
import style0 from "./postReComment.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postReComment.vue"
export default component.exports